"use client";

import { useContext } from "react";
import { IntakeContext } from "./IntakeContext";

export function useIntake() {
  const context = useContext(IntakeContext);
  if (context === undefined) {
    throw new Error("useIntake must be used within a IntakeProvider");
  }
  return context;
}
